export default __webpack_public_path__ + "3c1b4cbe80d7783a9426a480ac6d1574.png";